import { render, staticRenderFns } from "./veStuHygieneNormShow.vue?vue&type=template&id=4cea5996&scoped=true"
import script from "./veStuHygieneNormShow.vue?vue&type=script&lang=js"
export * from "./veStuHygieneNormShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea5996",
  null
  
)

export default component.exports